import { Link } from "react-router-dom"
import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Primary = styled(Link)`
  font-size: 12px;
  color: ${Color.primary};
  text-decoration: none;
  display: flex;
  align-items: center;
  margin-top: 6px;
  margin: ${({ m }) => m};
  margin-right: ${({ mr }) => mr}px;
  margin-left: ${({ ml }) => ml}px;
  margin-top: ${({ mt }) => mt}px;
  margin-bottom: ${({ mb }) => mb}px;
  cursor: pointer;

  @media (min-width: 640px) {
    font-size: 14px;
    margin-top: 8px;
  }

  @media (min-width: 1280px) {
    font-size: 18px;
    margin-top: 14px;
  }

  & i {
    font-size: 14px;
    margin-left: 6px;

    @media (min-width: 1280px) {
      font-size: 18px;
      margin-top: 4px;
    }
  }

  &:hover {
    color: #048cc7;
  }
  &:hover i {
    color: #048cc7;
  }
`

export const Rating = styled.div`
  display: flex;
  position: absolute;
  left: 8px;
  bottom: 10px;
  padding: 2px 6px;
  font-weight: 700;
  background: ${({ bg }) => (bg ? bg : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.24) 100%)")};
  color: ${({ color }) => color};
  /* border-bottom: 0.5px solid ${({ color }) => color}; */
  /* border-top: 0.5px solid ${({ color }) => color}; */
  border-radius: 3px;
  opacity: 0.9;
  z-index: 2;

  &i {
    margin-right: 4px;
  }
`

export const LoadMore = styled.button`
  padding: 12px 20px;
  font-size: 20px;
  border: none;
  outline: none;
  background: ${Color.gray800};
  color: ${Color.gray100};
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: ${Color.gray600};
  }
`
